// File: src/pages/CreateHeriarchy.jsx

import React, { useEffect, useMemo, useState } from "react";
import { Row, Col, Card, Button, Input, Spinner, Label } from "reactstrap";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";

import {
  Deptartment_with_Role,
  List_Department,
  Save_Assigned_Role,
  ViewDepartmentWise_Assign_Role,
  Update_AssignRole_InDepartment1,
} from "../import/ApiEndPoint/Api";

import {
  _Get,
  _GetList,
  _PostSave,
  _Put,
  Get_RoleList,
} from "../import/ApiEndPoint/ApiCalling";

import { FaPlus } from "react-icons/fa";

const injectOnce = () => {
  if (document.getElementById("tree-inline-css")) return;

  const s = document.createElement("style");
  s.id = "tree-inline-css";
  s.textContent = `
    .p-toolbar .count-pill{ background:#eef2ff; color:#3730a3; font-weight:900; padding:3px 8px; border-radius:999px; font-size:12px; }
    .p-card{ border-radius:12px; border:1px solid #e5e7eb; }

    .dept-grid{ row-gap:10px; }
    .dept-card{ padding:8px; }
    .dept-head{ display:flex; align-items:center; justify-content:space-between; gap:8px; margin-bottom:6px; }
    .dept-title{ font-weight:900; font-size:13px; line-height:1.1; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
    .dept-right{ display:flex; align-items:center; gap:6px; flex-wrap:nowrap; }

    .mini-btn{
      border:1px solid #e5e7eb;
      background:#fff;
      border-radius:10px;
      padding:3px 10px;
      font-weight:900;
      cursor:pointer;
      font-size:12px;
      line-height:1;
      height:26px;
      display:inline-flex;
      align-items:center;
      white-space:nowrap;
      gap:6px;
    }
    .mini-btn:disabled{ opacity:0.6; cursor:not-allowed; }

    .badge{
      font-size:10px;
      font-weight:900;
      padding:2px 6px;
      border-radius:999px;
      border:1px solid #e5e7eb;
      background:#f8fafc;
      color:#334155;
      height:18px;
      display:inline-flex;
      align-items:center;
      line-height:1;
      white-space:nowrap;
    }
    .badge-fixed{ background:#eef2ff; border-color:#c7d2fe; color:#3730a3; }
    .badge-custom{ background:#ecfeff; border-color:#a5f3fc; color:#155e75; }
    .badge-empty{ background:#fff7ed; border-color:#fed7aa; color:#9a3412; }

    .tree-row{ display:flex; align-items:center; gap:6px; padding:4px 2px; border-radius:8px; }
    .tree-row:hover{ background:#f9fbff; }
    .toggle{ font-weight:900; cursor:pointer; min-width:22px; text-align:center; user-select:none; font-size:12px; line-height:1; }
    .node-box{ display:inline-flex; align-items:center; gap:6px; padding:4px 8px; border:1px solid #e5e7eb; border-radius:999px; font-size:12px; }
    .node-dept{ background:#fff; }
    .node-role{ background:#f6f8ff; }
    .badge-kind{ font-size:10px; border-radius:6px; padding:1px 6px; border:1px solid #e5e7eb; background:#fff; }

    .soft-divider{ height:1px; background:#f1f5f9; margin:6px 0; }
    .muted{ font-size:12px; color:#6b7280; padding:6px 4px; }

    .popup-wrap{ margin-top:12px; }
    .popup-card{
      border-radius:18px;
      border:1px solid #e5e7eb;
      background:#fff;
      box-shadow: 0 25px 70px rgba(15,23,42,0.12);
      overflow:hidden;
    }
    .popup-head{
      padding:10px 12px;
      border-bottom:1px solid #eef2ff;
      background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
      display:flex;
      gap:10px;
      align-items:center;
      flex-wrap:wrap;
    }
    .popup-title{
      font-weight:900;
      text-transform:uppercase;
      font-size:14px;
      display:flex;
      gap:10px;
      align-items:center;
      flex-wrap:wrap;
    }
    .pill{
      border:1px solid #e5e7eb;
      background:#fff;
      border-radius:999px;
      padding:3px 10px;
      font-size:12px;
      font-weight:900;
      display:inline-flex;
      align-items:center;
      gap:6px;
      max-width:520px;
      white-space:nowrap;
      overflow:hidden;
      text-overflow:ellipsis;
    }
    .pill.blue{ background:#eef2ff; border-color:#c7d2fe; color:#3730a3; }
    .pill.orange{ background:#fff7ed; border-color:#fed7aa; color:#9a3412; }
    .popup-tools{
      margin-left:auto;
      display:flex;
      gap:8px;
      align-items:center;
      flex-wrap:wrap;
    }
    .popup-body{ padding:12px; }
    .pane{
      width:100%;
      border:1px solid #e5e7eb;
      border-radius:16px;
      background:#fff;
      overflow:hidden;
    }
    .pane-head{
      background:#f8fafc;
      border-bottom:1px solid #e5e7eb;
      padding:10px 12px;
      display:flex;
      align-items:center;
      justify-content:space-between;
      gap:8px;
      font-weight:900;
      flex-wrap:wrap;
    }
    .pane-body{
      padding:10px;
      max-height:62vh;
      overflow:auto;
    }
    .smallhint{ font-size:12px; color:#64748b; font-weight:700; }

    .role-grid{
      display:grid;
      grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
      gap:10px;
    }
    .role-tile{
      border:1px solid #eef2ff;
      border-radius:16px;
      padding:10px;
      background:#fff;
      box-shadow: 0 6px 18px rgba(15,23,42,0.05);
      display:flex;
      align-items:center;
      gap:10px;
      cursor:pointer;
      user-select:none;
    }
    .role-tile:hover{ background:#f9fbff; }
    .role-tile.active{
      border-color:#c7d2fe;
      background:#eef2ff;
    }
    .role-name{
      flex:1;
      font-weight:900;
      font-size:13px;
      overflow:hidden;
      white-space:nowrap;
      text-overflow:ellipsis;
    }
    .role-mini{
      font-size:11px;
      font-weight:900;
      padding:2px 8px;
      border-radius:999px;
      border:1px solid #e5e7eb;
      background:#fff;
      color:#334155;
      display:inline-flex;
      align-items:center;
      white-space:nowrap;
      gap:6px;
    }
    .rank-box{
      width:96px;
      height:34px;
      font-weight:900;
      border-radius:10px;
    }

    .xbtn{
      border:1px solid #e5e7eb;
      background:#fff;
      border-radius:12px;
      width:32px;
      height:32px;
      display:flex;
      align-items:center;
      justify-content:center;
      font-weight:900;
      cursor:pointer;
      color:#ef4444;
      line-height:1;
    }
    .xbtn:hover{ background:#fff1f2; border-color:#fecaca; }

    .popup-foot{
      padding:10px 12px;
      border-top:1px solid #eef2ff;
      background:#fff;
      display:flex;
      gap:10px;
      align-items:center;
      justify-content:space-between;
      flex-wrap:wrap;
    }
    .popup-foot .left, .popup-foot .right{
      display:flex;
      gap:8px;
      flex-wrap:wrap;
      align-items:center;
    }
  `;

  document.head.appendChild(s);
};

const FIXED_DEPTS = [
  "Management",
  "Finance",
  "Order and Billing",
  "Sales",
  "Logistic",
];

const norm = (s) =>
  String(s || "")
    .trim()
    .toLowerCase();

const isFixedDept = (name) => FIXED_DEPTS.some((d) => norm(d) === norm(name));

const keyify = (s) =>
  String(s || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");

const GROUP_KEYS = ["salesmanager", "salesperson", "customer"];

const isGroupRoleName = (roleName) => GROUP_KEYS.includes(keyify(roleName));

const isDeptNode = (node) => !!node?.departmentName?.departmentName;

const getDeptTitle = (node) =>
  node?.departmentName?.departmentName ||
  node?.departmentName?.name ||
  node?.departmentName ||
  node?.name ||
  "-";

const getChildren = (node) => (Array.isArray(node?.roles) ? node.roles : []);

const getLabel = (node) => {
  if (isDeptNode(node)) return getDeptTitle(node);

  const roleName = node?.roleName || node?.roleId?.roleName || "-";

  return `${roleName}${
    node?.rolePosition ? ` (Position-${node.rolePosition})` : ""
  }`;
};

const makePathId = (pathArr) => pathArr.join(".");

const filterTree = (node, termLower) => {
  const label = getLabel(node).toLowerCase();

  const kids = getChildren(node)
    .map((c) => filterTree(c, termLower))
    .filter(Boolean);

  const selfHit = label.includes(termLower);

  return selfHit || kids.length ? { ...node, roles: kids } : null;
};

const collectAllPathIds = (nodes, path = []) => {
  const ids = [];

  nodes.forEach((node, i) => {
    const id = makePathId([...path, i]);
    ids.push(id);

    const children = getChildren(node);

    if (children.length) {
      ids.push(...collectAllPathIds(children, [...path, i]));
    }
  });

  return ids;
};

const countNodes = (nodes) => {
  let c = 0;

  const walk = (arr) =>
    arr.forEach((n) => {
      c += 1;

      const kids = getChildren(n);

      if (kids.length) walk(kids);
    });

  walk(nodes);

  return c;
};

const mongoIdLike = (v) => /^[a-f\d]{24}$/i.test(String(v || ""));

const sameId = (a, b) => String(a || "") === String(b || "");

const safeId = (v) => {
  if (!v) return "";
  if (typeof v === "object") return String(v?._id || v?.id || "");
  return String(v);
};

const getDeptIdFromMaster = (d) =>
  safeId(d?._id || d?.id || d?.departmentName?._id || d?.departmentName?.id);

const getDeptNameFromMaster = (d) =>
  d?.departmentName?.departmentName ||
  d?.departmentName?.name ||
  (!mongoIdLike(d?.departmentName) && typeof d?.departmentName === "string"
    ? d.departmentName
    : "") ||
  d?.name ||
  "-";

const getDeptIdFromAssignedNode = (node) => {
  const dep = node?.departmentName || node?.departmentId || node?.department;

  if (typeof dep === "object") return safeId(dep?._id || dep?.id);
  if (typeof dep === "string" && mongoIdLike(dep)) return dep;

  return "";
};

const getDeptNameFromAssignedNode = (node, activeById = new Map()) => {
  const dep = node?.departmentName || node?.departmentId || node?.department;
  const depId = getDeptIdFromAssignedNode(node);

  if (depId && activeById.has(depId)) return activeById.get(depId)?.name || "";

  if (typeof dep === "object") {
    return dep?.departmentName || dep?.name || "";
  }

  if (typeof dep === "string" && !mongoIdLike(dep)) return dep;

  return "";
};

const normalizeAssignedRoles = (roles = []) =>
  (Array.isArray(roles) ? roles : []).map((r) => ({
    ...r,
    roleName: r?.roleName || r?.roleId?.roleName || r?.name || "-",
    roleId: r?.roleId?._id || r?.roleId || r?._id,
    database: r?.database || r?.roleId?.database,
    rolePosition: r?.rolePosition ?? r?.createdPosition ?? "",
  }));

const getRealRoleId = (role) =>
  String(role?.roleId?._id || role?.roleId || role?._id || "");

const roleUniqueKey = (r) =>
  String(r?.roleId?._id || r?.roleId || r?._id || keyify(r?.roleName));

const mergeRoles = (oldRoles = [], newRoles = []) => {
  const map = new Map();

  [...oldRoles, ...newRoles].forEach((role) => {
    const key = roleUniqueKey(role);

    if (!key) return;

    map.set(key, {
      ...(map.get(key) || {}),
      ...role,
    });
  });

  return Array.from(map.values());
};

const putRoles = (map, key, roles) => {
  if (!key) return;

  const k = String(key);

  map.set(k, mergeRoles(map.get(k) || [], roles));
};

const collectAssignedRoleIdsFromTree = (nodes = []) => {
  const ids = new Set();

  const walk = (arr = []) => {
    arr.forEach((node) => {
      const kids = getChildren(node);

      if (!isDeptNode(node)) {
        const roleId = getRealRoleId(node);

        if (roleId) ids.add(roleId);
      }

      if (kids.length) walk(kids);
    });
  };

  walk(nodes);

  return ids;
};

const collectRoleKeysDeep = (node, out = new Set()) => {
  if (!isDeptNode(node) && node?.roleName) {
    out.add(keyify(node.roleName));
  }

  if (!isDeptNode(node) && node?.roleId?.roleName) {
    out.add(keyify(node.roleId.roleName));
  }

  const kids = getChildren(node);

  kids.forEach((k) => collectRoleKeysDeep(k, out));

  return out;
};

const findDeptWithAllGroupRoles = (roots) => {
  for (const deptNode of roots || []) {
    const set = collectRoleKeysDeep(deptNode, new Set());
    const hasAll = GROUP_KEYS.every((k) => set.has(k));

    if (hasAll) {
      const deptId =
        deptNode?.departmentName?._id ||
        deptNode?.departmentName?.id ||
        deptNode?._id ||
        null;

      const deptName = getDeptTitle(deptNode);

      return {
        deptId: String(deptId || ""),
        deptName,
      };
    }
  }

  return null;
};

const findGroupRoleLocations = (roots) => {
  const map = {
    salesmanager: new Set(),
    salesperson: new Set(),
    customer: new Set(),
  };

  (roots || []).forEach((deptNode) => {
    const deptName = getDeptTitle(deptNode);
    const deptKeys = collectRoleKeysDeep(deptNode, new Set());

    GROUP_KEYS.forEach((k) => {
      if (deptKeys.has(k)) map[k].add(deptName);
    });
  });

  return map;
};

const TreeNode = ({ node, depth, path, expanded, onToggle }) => {
  const id = path.join(".");
  const children = getChildren(node);
  const hasChildren = children.length > 0;
  const open = expanded.has(id);

  const dept = isDeptNode(node);
  const label = getLabel(node);

  return (
    <>
      <div className="tree-row" style={{ marginLeft: depth * 12 }}>
        <span className="toggle" onClick={() => hasChildren && onToggle(id)}>
          {hasChildren ? (open ? "−" : "+") : ""}
        </span>

        <div className={`node-box ${dept ? "node-dept" : "node-role"}`}>
          <span style={{ fontWeight: 900 }}>{label}</span>
          <span className="badge-kind">{dept ? "Dept" : "Role"}</span>
        </div>
      </div>

      {open &&
        children.map((child, idx) => (
          <TreeNode
            key={[...path, idx].join(".")}
            node={child}
            depth={depth + 1}
            path={[...path, idx]}
            expanded={expanded}
            onToggle={onToggle}
          />
        ))}
    </>
  );
};

export default function CreateHeriarchy() {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [raw, setRaw] = useState([]);
  const [search, setSearch] = useState("");
  const [expanded, setExpanded] = useState(new Set());

  const [bundleDept, setBundleDept] = useState({
    deptId: "",
    deptName: "",
  });

  const [popupOpen, setPopupOpen] = useState(false);
  const [popupMode, setPopupMode] = useState("assign");
  const [popupDeptId, setPopupDeptId] = useState("");
  const [popupDeptName, setPopupDeptName] = useState("");

  const [assignRoles, setAssignRoles] = useState([]);
  const [assignSelectedRoles, setAssignSelectedRoles] = useState([]);
  const [assignSearch, setAssignSearch] = useState("");
  const [assignLoading, setAssignLoading] = useState(false);
  const [assignSaving, setAssignSaving] = useState(false);

  const [editLoading, setEditLoading] = useState(false);
  const [editSaving, setEditSaving] = useState(false);
  const [editAssignDoc, setEditAssignDoc] = useState(null);
  const [changedDept, setChangedDept] = useState(null);
  const [deletedRoles, setDeletedRoles] = useState([]);

  useEffect(() => {
    injectOnce();
  }, []);

  const buildMergedTree = (allDepartmentsActive, deptWithRoles) => {
    const roleMapById = new Map();
    const roleMapByName = new Map();

    const activeDeptList = (
      Array.isArray(allDepartmentsActive) ? allDepartmentsActive : []
    ).map((d) => {
      const id = getDeptIdFromMaster(d);
      const name = getDeptNameFromMaster(d);

      return {
        id,
        name,
        original: d,
      };
    });

    const activeById = new Map(
      activeDeptList.filter((d) => d.id).map((d) => [String(d.id), d]),
    );

    (Array.isArray(deptWithRoles) ? deptWithRoles : []).forEach((node) => {
      const depId = getDeptIdFromAssignedNode(node);
      const depName = getDeptNameFromAssignedNode(node, activeById);
      const roles = normalizeAssignedRoles(node?.roles);

      if (depId) putRoles(roleMapById, depId, roles);
      if (depName) putRoles(roleMapByName, norm(depName), roles);
    });

    const roots = activeDeptList.map((d) => {
      const roles =
        (d.id && roleMapById.get(String(d.id))) ||
        roleMapByName.get(norm(d.name)) ||
        [];

      return {
        departmentName: {
          _id: d.id,
          departmentName: d.name,
        },
        roles,
      };
    });

    const existingIds = new Set(
      roots.map((r) => String(r?.departmentName?._id || "")).filter(Boolean),
    );

    const existingNames = new Set(roots.map((r) => norm(getDeptTitle(r))));

    (Array.isArray(deptWithRoles) ? deptWithRoles : []).forEach((node) => {
      const depId = getDeptIdFromAssignedNode(node);
      const depName = getDeptNameFromAssignedNode(node, activeById);

      if (!depId && !depName) return;
      if (depId && existingIds.has(String(depId))) return;
      if (depName && existingNames.has(norm(depName))) return;

      roots.push({
        departmentName: {
          _id: depId,
          departmentName: depName || "Unknown Department",
        },
        roles: normalizeAssignedRoles(node?.roles),
      });

      if (depId) existingIds.add(String(depId));
      if (depName) existingNames.add(norm(depName));
    });

    roots.sort((a, b) => {
      const an = getDeptTitle(a);
      const bn = getDeptTitle(b);

      const ai = FIXED_DEPTS.findIndex((x) => norm(x) === norm(an));
      const bi = FIXED_DEPTS.findIndex((x) => norm(x) === norm(bn));

      const aRank = ai === -1 ? 9999 : ai;
      const bRank = bi === -1 ? 9999 : bi;

      if (aRank !== bRank) return aRank - bRank;

      return String(an || "").localeCompare(String(bn || ""));
    });

    return roots;
  };

  const load = async () => {
    setLoading(true);

    try {
      const user = JSON.parse(localStorage.getItem("userData") || "{}");

      if (!user?.database) {
        setRaw([]);
        setExpanded(new Set());
        setBundleDept({ deptId: "", deptName: "" });
        return;
      }

      let activeDepts = [];
      let deptWithRoles = [];

      try {
        const depRes = await _GetList(`${List_Department}/${user.database}`);

        const allDepts = Array.isArray(depRes?.Department)
          ? depRes.Department
          : [];

        activeDepts = allDepts.filter(
          (d) => !d?.status || String(d?.status).toLowerCase() === "active",
        );
      } catch (depErr) {
        console.error("[CreateHeriarchy] department list error:", depErr);
        activeDepts = [];
      }

      try {
        const [structureRes, assignedRoleRes] = await Promise.allSettled([
          _Get(Deptartment_with_Role, user.database),
          _Get(ViewDepartmentWise_Assign_Role, user.database),
        ]);

        const structureDepartments =
          structureRes.status === "fulfilled" &&
          Array.isArray(structureRes.value?.Department)
            ? structureRes.value.Department
            : [];

        const assignedDepartments =
          assignedRoleRes.status === "fulfilled" &&
          Array.isArray(assignedRoleRes.value?.Department)
            ? assignedRoleRes.value.Department
            : [];

        deptWithRoles = [...structureDepartments, ...assignedDepartments];

        console.log(
          "[CreateHeriarchy] merged assigned role rows:",
          deptWithRoles,
        );
      } catch (roleErr) {
        console.warn(
          "[CreateHeriarchy] organization structure not found, showing departments only:",
          roleErr,
        );

        deptWithRoles = [];
      }

      const merged = buildMergedTree(activeDepts, deptWithRoles);

      setRaw(merged);
      setExpanded(new Set());

      const found = findDeptWithAllGroupRoles(merged);

      if (found?.deptId) {
        setBundleDept({
          deptId: found.deptId,
          deptName: found.deptName,
        });

        console.log("Bundle Roles Department:", found.deptName);
      } else {
        setBundleDept({
          deptId: "",
          deptName: "",
        });

        const locations = findGroupRoleLocations(merged);

        console.log("Bundle roles not together / not assigned yet:", {
          salesManager: Array.from(locations.salesmanager || []),
          salesPerson: Array.from(locations.salesperson || []),
          customer: Array.from(locations.customer || []),
        });

        const allPlaces = new Set([
          ...Array.from(locations.salesmanager || []),
          ...Array.from(locations.salesperson || []),
          ...Array.from(locations.customer || []),
        ]);

        if (allPlaces.size > 1) {
          console.log(
            "Bundle rule violated: Sales Manager / Sales Person / Customer appear in multiple departments.",
          );
        }
      }
    } catch (err) {
      console.log("[CreateHeriarchy] fetch error:", err);
      swal("Failed to load departments");

      setRaw([]);
      setBundleDept({
        deptId: "",
        deptName: "",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const filteredData = useMemo(() => {
    const term = search.trim().toLowerCase();

    if (!term) return raw;

    return raw.map((r) => filterTree(r, term)).filter(Boolean);
  }, [raw, search]);

  useEffect(() => {
    if (search.trim()) setExpanded(new Set(collectAllPathIds(filteredData)));
    else setExpanded(new Set());
  }, [search, filteredData]);

  const totalNodes = useMemo(() => countNodes(filteredData), [filteredData]);

  const actuallyAssignedRoleIds = useMemo(
    () => collectAssignedRoleIdsFromTree(raw),
    [raw],
  );

  const onToggle = (id) => {
    setExpanded((prev) => {
      const next = new Set(prev);

      next.has(id) ? next.delete(id) : next.add(id);

      return next;
    });
  };

  const toggleDeptRoot = (rootIndex) => onToggle(makePathId([rootIndex]));

  const closePopup = () => {
    setPopupOpen(false);
    setPopupMode("assign");
    setPopupDeptId("");
    setPopupDeptName("");

    setAssignRoles([]);
    setAssignSelectedRoles([]);
    setAssignSearch("");
    setAssignLoading(false);
    setAssignSaving(false);

    setEditAssignDoc(null);
    setChangedDept(null);
    setDeletedRoles([]);
    setEditLoading(false);
    setEditSaving(false);
  };

  const scrollToPopup = () => {
    setTimeout(() => {
      const el = document.getElementById("hierarchy-popup-window");

      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 50);
  };

  const loadAssignableRoles = async () => {
    setAssignLoading(true);

    try {
      const user = JSON.parse(localStorage.getItem("userData") || "{}");
      const roleRes = await Get_RoleList(user?._id, user?.database);

      const all = Array.isArray(roleRes?.Role) ? roleRes.Role : [];
      const allWithoutSuper = all.filter((r) => r?.roleName !== "SuperAdmin");

      allWithoutSuper.sort((a, b) =>
        String(a?.roleName || "").localeCompare(String(b?.roleName || "")),
      );

      setAssignRoles(allWithoutSuper);
    } catch (e) {
      console.error("[AssignPopup] roles load error:", e);
      swal("Failed to load roles");
      setAssignRoles([]);
    } finally {
      setAssignLoading(false);
    }
  };

  const openAssignPopup = async (deptId, deptName) => {
    if (!deptId) return swal("Department not found");

    setPopupMode("assign");
    setPopupDeptId(String(deptId));
    setPopupDeptName(deptName || "-");
    setPopupOpen(true);

    setAssignSelectedRoles([]);
    setAssignSearch("");
    setAssignRoles([]);

    setEditAssignDoc(null);
    setChangedDept(null);
    setDeletedRoles([]);

    await loadAssignableRoles();
    scrollToPopup();
  };

  const filteredAssignRoles = useMemo(() => {
    const term = assignSearch.trim().toLowerCase();

    const availableOnly = (assignRoles || []).filter((r) => {
      const roleId = getRealRoleId(r);

      if (!roleId) return true;

      return !actuallyAssignedRoleIds.has(roleId);
    });

    if (!term) return availableOnly;

    return availableOnly.filter((r) =>
      String(r?.roleName || "")
        .toLowerCase()
        .includes(term),
    );
  }, [assignRoles, assignSearch, actuallyAssignedRoleIds]);

  const isAssignSelected = (roleId) =>
    assignSelectedRoles.some((s) => s?._id === roleId);

  const getAssignRank = (roleId) =>
    assignSelectedRoles.find((s) => s?._id === roleId)?.createdPosition || "";

  const bundleLockedToOtherDept =
    !!bundleDept?.deptId && String(bundleDept.deptId) !== String(popupDeptId);

  const toggleAssignRole = (role) => {
    const roleKey = keyify(role?.roleName);

    if (GROUP_KEYS.includes(roleKey) && bundleLockedToOtherDept) {
      return swal(
        `Sales Manager, Sales Person and Customer must be in the SAME department.\n\nAlready found in: ${bundleDept.deptName}`,
      );
    }

    setAssignSelectedRoles((prev) => {
      const exists = prev.some((s) => s?._id === role?._id);

      if (GROUP_KEYS.includes(roleKey)) {
        if (exists) {
          return prev.filter((x) => !GROUP_KEYS.includes(keyify(x?.roleName)));
        }

        const already = [...prev];
        const add = [];

        (filteredAssignRoles || []).forEach((r) => {
          if (!r?._id) return;
          if (!GROUP_KEYS.includes(keyify(r?.roleName))) return;
          if (already.some((x) => x?._id === r?._id)) return;

          add.push(r);
        });

        if (!add.some((x) => x?._id === role?._id) && role?._id) {
          add.push(role);
        }

        return [...already, ...add];
      }

      if (exists) return prev.filter((s) => s?._id !== role?._id);

      return [...prev, role];
    });
  };

  const setAssignRankFor = (roleId, rank) => {
    setAssignSelectedRoles((prev) =>
      prev.map((r) =>
        r?._id === roleId
          ? {
              ...r,
              createdPosition: Number(rank),
            }
          : r,
      ),
    );
  };

  const saveAssignRoles = async () => {
    if (!popupDeptId) return swal("Department not found");

    if (assignSelectedRoles.length === 0) {
      return swal("Please select at least one role");
    }

    const selectedKeys = new Set(
      assignSelectedRoles.map((r) => keyify(r?.roleName)),
    );

    const hasAnyBundle = GROUP_KEYS.some((k) => selectedKeys.has(k));
    const hasAllBundle = GROUP_KEYS.every((k) => selectedKeys.has(k));

    if (hasAnyBundle && !hasAllBundle) {
      return swal(
        "Sales Manager, Sales Person and Customer must be selected together (same department).",
      );
    }

    const user = JSON.parse(localStorage.getItem("userData") || "{}");

    const mainData = assignSelectedRoles.map((r) => ({
      roleName: r?.roleName,
      database: r?.database || user?.database,
      roleId: r?._id,
      rolePosition: r?.createdPosition,
    }));

    const payload = {
      created_by: user?._id,
      database: user?.database,
      departmentName: popupDeptId,
      roles: mainData,
    };

    try {
      setAssignSaving(true);

      const res = await _PostSave(Save_Assigned_Role, payload);

      if (res) {
        swal("Roles Assigned Successfully");
        await load();
        closePopup();
      }
    } catch (e) {
      console.error("[AssignPopup] save error:", e);
      swal("Something went wrong");
    } finally {
      setAssignSaving(false);
    }
  };

  const loadEditDepartment = async (deptId, deptName = "") => {
    setEditLoading(true);

    try {
      const user = JSON.parse(localStorage.getItem("userData") || "{}");
      const res = await _Get(ViewDepartmentWise_Assign_Role, user?.database);
      const arr = Array.isArray(res?.Department) ? res.Department : [];

      const found = arr.find((d) => {
        const assignedDeptId = getDeptIdFromAssignedNode(d);
        const assignedDeptName = getDeptNameFromAssignedNode(d);

        return (
          sameId(assignedDeptId, deptId) ||
          sameId(d?._id, deptId) ||
          (!!deptName && norm(assignedDeptName) === norm(deptName))
        );
      });

      if (!found) {
        setEditAssignDoc(null);
        setChangedDept(null);
        return;
      }

      const normalized = {
        ...found,
        roles: normalizeAssignedRoles(found?.roles),
      };

      setEditAssignDoc(normalized);
      setChangedDept(normalized);
    } catch (e) {
      console.error("[EditPopup] load error:", e);
      swal("Failed to load department roles");
      setEditAssignDoc(null);
      setChangedDept(null);
    } finally {
      setEditLoading(false);
    }
  };

  const openEditPopup = async (deptId, deptName) => {
    if (!deptId) return swal("Department not found");

    setPopupMode("edit");
    setPopupDeptId(String(deptId));
    setPopupDeptName(deptName || "-");
    setPopupOpen(true);

    setAssignRoles([]);
    setAssignSelectedRoles([]);
    setAssignSearch("");

    setDeletedRoles([]);
    setEditAssignDoc(null);
    setChangedDept(null);

    await loadEditDepartment(deptId, deptName);
    scrollToPopup();
  };

  const updateRank = (idx, newRank) => {
    const val = Number(newRank);
    const deptCopy = { ...(changedDept || editAssignDoc) };
    const list = Array.isArray(deptCopy?.roles) ? [...deptCopy.roles] : [];

    if (!list[idx]) return;

    list[idx] = {
      ...list[idx],
      rolePosition: val,
    };

    deptCopy.roles = list;
    setChangedDept(deptCopy);
  };

  const deleteRole = (roleObj) => {
    const roleKey = keyify(roleObj?.roleName || roleObj?.roleId?.roleName);

    if (GROUP_KEYS.includes(roleKey)) {
      return swal(
        "Bundle Rule",
        "Sales Manager, Sales Person and Customer must stay together in the SAME department.\n\nDo you want to remove ALL three from this department?",
        {
          buttons: {
            catch: {
              text: "Remove All 3",
              value: "delete",
            },
            cancel: "Cancel",
          },
        },
      ).then((value) => {
        if (value !== "delete") return;

        const deptCopy = { ...(changedDept || editAssignDoc) };
        const list = Array.isArray(deptCopy?.roles) ? [...deptCopy.roles] : [];

        const toRemove = list.filter((r) =>
          GROUP_KEYS.includes(keyify(r?.roleName || r?.roleId?.roleName)),
        );

        if (toRemove.length === 0) return;

        const remaining = list.filter(
          (r) =>
            !GROUP_KEYS.includes(keyify(r?.roleName || r?.roleId?.roleName)),
        );

        deptCopy.roles = remaining;

        setDeletedRoles((prev) => [...prev, ...toRemove]);
        setChangedDept(deptCopy);
      });
    }

    swal("Warning", "Sure You Want to Delete Role", {
      buttons: {
        catch: {
          text: "Delete",
          value: "delete",
        },
        cancel: "Cancel",
      },
    }).then((value) => {
      if (value !== "delete") return;

      const deptCopy = { ...(changedDept || editAssignDoc) };
      const list = Array.isArray(deptCopy?.roles) ? [...deptCopy.roles] : [];
      const idx = list.indexOf(roleObj);

      if (idx >= 0) list.splice(idx, 1);

      deptCopy.roles = list;

      setDeletedRoles((prev) => [...prev, roleObj]);
      setChangedDept(deptCopy);
    });
  };

  const saveEditChanges = async () => {
    if (!changedDept?._id) {
      return swal("No hierarchy found. Use + to assign roles first.");
    }

    const rolesNow = changedDept?.roles || [];

    const keysNow = new Set(
      rolesNow.map((r) => keyify(r?.roleName || r?.roleId?.roleName)),
    );

    const hasAnyBundle = GROUP_KEYS.some((k) => keysNow.has(k));
    const hasAllBundle = GROUP_KEYS.every((k) => keysNow.has(k));

    if (hasAnyBundle && !hasAllBundle) {
      return swal(
        "Bundle Rule: Sales Manager, Sales Person and Customer must be together in the same department.",
      );
    }

    const currentRoles = rolesNow.map((val) => ({
      database: val?.database,
      roleName: val?.roleName || val?.roleId?.roleName,
      roleId: val?.roleId?._id || val?.roleId || val?._id,
      rolePosition: val?.rolePosition,
    }));

    const removed = (deletedRoles || []).map((val) => ({
      database: val?.database,
      roleName: val?.roleName || val?.roleId?.roleName,
      roleId: val?.roleId?._id || val?.roleId || val?._id,
      rolePosition: val?.rolePosition,
    }));

    try {
      setEditSaving(true);

      const res = await _Put(
        Update_AssignRole_InDepartment1,
        changedDept?._id,
        {
          roles: currentRoles,
          deleteRole: removed,
        },
      );

      if (res) {
        swal("Roles Changed Successfully");
        await load();
        closePopup();
      }
    } catch (e) {
      console.error("[EditPopup] save error:", e);
      swal("Something went wrong");
    } finally {
      setEditSaving(false);
    }
  };

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "20rem",
        }}
      >
        <Spinner style={{ height: "4rem", width: "4rem" }} color="primary">
          Loading...
        </Spinner>
      </div>
    );
  }

  return (
    <>
      <Row className="p-toolbar" style={{ marginBottom: 10 }}>
        <Col sm="12">
          <Card
            className="p-card"
            style={{ padding: 8, background: "#f4f7f6" }}
          >
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: 10,
                alignItems: "center",
              }}
            >
              <div
                style={{
                  fontWeight: 900,
                  textTransform: "uppercase",
                  fontSize: 16,
                }}
              >
                Organization Structure{" "}
                <span className="count-pill">{totalNodes}</span>
              </div>

              <div style={{ flex: "1 1 240px" }} />

              <div
                style={{
                  minWidth: 260,
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                <Input
                  bsSize="sm"
                  placeholder="Search departments or roles..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>

              <Button
                style={{
                  backgroundColor: "rgb(8, 91, 245)",
                  color: "white",
                  fontWeight: 800,
                  height: 30,
                  fontSize: 13,
                  padding: "0 10px",
                }}
                onClick={load}
              >
                Refresh
              </Button>

              <Button
                style={{
                  backgroundColor: "rgb(8, 91, 245)",
                  color: "white",
                  fontWeight: 800,
                  height: 30,
                  fontSize: 13,
                  padding: "0 10px",
                }}
                onClick={() => navigate(-1)}
              >
                Back
              </Button>
            </div>
          </Card>
        </Col>
      </Row>

      {filteredData.length === 0 ? (
        <Row>
          <Col sm="12">
            <Card className="p-card" style={{ padding: 14 }}>
              No Organization Structure found.
            </Card>
          </Col>
        </Row>
      ) : (
        <Row className="dept-grid">
          {filteredData.map((deptNode, rootIndex) => {
            const deptName = getDeptTitle(deptNode);
            const fixed = isFixedDept(deptName);

            const depId =
              deptNode?.departmentName?._id ||
              deptNode?.departmentName?.id ||
              deptNode?._id ||
              null;

            const rootId = makePathId([rootIndex]);
            const rootOpen = expanded.has(rootId);

            const rolesCount = getChildren(deptNode).length;

            return (
              <Col key={rootIndex} xl="3" lg="4" md="6" sm="12">
                <Card className="p-card dept-card">
                  <div className="dept-head">
                    <div className="dept-title" title={deptName}>
                      {deptName}
                    </div>

                    <div className="dept-right">
                      <span
                        className={`badge ${
                          fixed ? "badge-fixed" : "badge-custom"
                        }`}
                      >
                        {fixed ? "Fixed" : "Custom"}
                      </span>

                      {rolesCount === 0 ? (
                        <span className="badge badge-empty">No Roles</span>
                      ) : null}

                      <button
                        className="mini-btn"
                        title="Assign roles"
                        onClick={() => openAssignPopup(depId, deptName)}
                        disabled={!depId}
                      >
                        <FaPlus size={10} />
                      </button>

                      <button
                        className="mini-btn"
                        onClick={() => toggleDeptRoot(rootIndex)}
                        title="Expand / Collapse"
                      >
                        {rootOpen ? "Hide" : "Show"}
                      </button>

                      <button
                        className="mini-btn"
                        onClick={() => openEditPopup(depId, deptName)}
                        title="Edit roles / ranks"
                        disabled={!depId}
                      >
                        Edit
                      </button>
                    </div>
                  </div>

                  {rootOpen ? (
                    <>
                      <div className="soft-divider" />

                      <div className="tree-wrap" style={{ padding: 0 }}>
                        <TreeNode
                          node={deptNode}
                          depth={0}
                          path={[rootIndex]}
                          expanded={expanded}
                          onToggle={onToggle}
                        />

                        {rolesCount === 0 ? (
                          <div className="muted">
                            No roles assigned in this department.
                          </div>
                        ) : null}
                      </div>
                    </>
                  ) : null}
                </Card>
              </Col>
            );
          })}
        </Row>
      )}

      {popupOpen ? (
        <Row className="popup-wrap">
          <Col sm="12">
            <div id="hierarchy-popup-window" className="popup-card">
              <div className="popup-head">
                <div className="popup-title">
                  {popupMode === "assign"
                    ? "Assign Roles"
                    : "Edit Department Hierarchy"}

                  <span className="pill blue" title={popupDeptName}>
                    Dept: {popupDeptName || "-"}
                  </span>

                  {bundleDept?.deptId ? (
                    <span className="pill orange" title={bundleDept.deptName}>
                      Bundle Dept: {bundleDept.deptName}
                    </span>
                  ) : null}

                  {popupMode === "assign" ? (
                    <span className="pill orange">
                      Selected: {assignSelectedRoles.length}
                    </span>
                  ) : (
                    <span className="pill orange">
                      Roles:{" "}
                      {(changedDept?.roles || editAssignDoc?.roles || [])
                        .length || 0}
                    </span>
                  )}
                </div>

                <div className="popup-tools">
                  {popupMode === "assign" ? (
                    <Input
                      bsSize="sm"
                      style={{ width: 320 }}
                      placeholder="Search roles..."
                      value={assignSearch}
                      onChange={(e) => setAssignSearch(e.target.value)}
                    />
                  ) : null}

                  <Button
                    size="sm"
                    outline
                    color="secondary"
                    onClick={closePopup}
                  >
                    Close
                  </Button>
                </div>
              </div>

              <div className="popup-body">
                <div className="pane">
                  <div className="pane-head">
                    {popupMode === "assign" ? (
                      <>
                        <div>Available Roles (Grid + Rank)</div>
                        <div className="smallhint">
                          {filteredAssignRoles.length} roles available
                        </div>
                      </>
                    ) : (
                      <>
                        <div>Roles (Grid + Rank)</div>
                        <div className="smallhint">
                          Change rank / remove roles
                        </div>
                      </>
                    )}
                  </div>

                  <div className="pane-body">
                    {popupMode === "assign" ? (
                      assignLoading ? (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            margin: "2rem 0",
                          }}
                        >
                          <Spinner style={{ height: "3rem", width: "3rem" }} />
                        </div>
                      ) : filteredAssignRoles.length === 0 ? (
                        <div className="muted">
                          No available roles. If roles exist in Role Master,
                          click Refresh and try again.
                        </div>
                      ) : (
                        <div className="role-grid">
                          {filteredAssignRoles.map((role) => {
                            const active = isAssignSelected(role?._id);
                            const rank = getAssignRank(role?._id);
                            const isBundle = isGroupRoleName(role?.roleName);
                            const blocked = isBundle && bundleLockedToOtherDept;

                            return (
                              <div
                                key={role?._id}
                                className={`role-tile ${
                                  active ? "active" : ""
                                }`}
                                onClick={() =>
                                  !blocked && toggleAssignRole(role)
                                }
                                title={role?.roleName || ""}
                                style={{
                                  opacity: blocked ? 0.55 : 1,
                                  cursor: blocked ? "not-allowed" : "pointer",
                                }}
                              >
                                <Input
                                  type="checkbox"
                                  checked={active}
                                  onChange={() =>
                                    !blocked && toggleAssignRole(role)
                                  }
                                  style={{ width: 18, height: 18 }}
                                  onClick={(e) => e.stopPropagation()}
                                  disabled={blocked}
                                />

                                <div className="role-name">
                                  {role?.roleName || "-"}
                                </div>

                                {isBundle ? (
                                  <span className="role-mini">BUNDLE</span>
                                ) : null}

                                <Input
                                  className="rank-box"
                                  bsSize="sm"
                                  type="number"
                                  placeholder="Rank"
                                  value={rank}
                                  disabled={!active || blocked}
                                  onClick={(e) => e.stopPropagation()}
                                  onChange={(e) =>
                                    setAssignRankFor(role?._id, e.target.value)
                                  }
                                />
                              </div>
                            );
                          })}
                        </div>
                      )
                    ) : null}

                    {popupMode === "edit" ? (
                      editLoading ? (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            margin: "2rem 0",
                          }}
                        >
                          <Spinner style={{ height: "3rem", width: "3rem" }} />
                        </div>
                      ) : !editAssignDoc ? (
                        <Card
                          className="p-card"
                          style={{ padding: 14, textAlign: "center" }}
                        >
                          <div style={{ fontWeight: 900, marginBottom: 6 }}>
                            No hierarchy found for this department.
                          </div>

                          <div style={{ color: "#64748b", fontWeight: 700 }}>
                            Use the <b>+</b> button on this department to assign
                            roles first.
                          </div>
                        </Card>
                      ) : (changedDept?.roles || editAssignDoc?.roles || [])
                          .length === 0 ? (
                        <div className="muted">No roles assigned.</div>
                      ) : (
                        <div className="role-grid">
                          {(
                            changedDept?.roles ||
                            editAssignDoc?.roles ||
                            []
                          ).map((role, idx) => {
                            const roleName =
                              role?.roleName || role?.roleId?.roleName || "-";

                            const rankVal = role?.rolePosition ?? "";

                            const key =
                              role?.roleId?._id ||
                              role?.roleId ||
                              role?._id ||
                              `${idx}`;

                            const isBundle = isGroupRoleName(roleName);

                            return (
                              <div
                                key={key}
                                className="role-tile"
                                style={{ cursor: "default" }}
                              >
                                <button
                                  className="xbtn"
                                  title="Remove role"
                                  onClick={() => deleteRole(role)}
                                >
                                  ×
                                </button>

                                <div className="role-name" title={roleName}>
                                  {roleName}
                                </div>

                                {isBundle ? (
                                  <span className="role-mini">BUNDLE</span>
                                ) : (
                                  <span className="role-mini">Rank</span>
                                )}

                                <Input
                                  className="rank-box"
                                  bsSize="sm"
                                  type="number"
                                  placeholder="Rank"
                                  value={String(rankVal)}
                                  onChange={(e) =>
                                    updateRank(idx, e.target.value)
                                  }
                                />
                              </div>
                            );
                          })}
                        </div>
                      )
                    ) : null}
                  </div>
                </div>
              </div>

              <div className="popup-foot">
                <div className="left">
                  {popupMode === "assign" ? (
                    <Button
                      size="sm"
                      outline
                      color="secondary"
                      onClick={() => setAssignSelectedRoles([])}
                      disabled={assignSelectedRoles.length === 0}
                    >
                      Clear Selection
                    </Button>
                  ) : (
                    <Label className="smallhint" style={{ margin: 0 }}>
                      Removing roles will delete them from this department.
                      Bundle roles are removed together.
                    </Label>
                  )}
                </div>

                <div className="right">
                  <Button
                    size="sm"
                    outline
                    color="secondary"
                    onClick={closePopup}
                  >
                    Cancel
                  </Button>

                  {popupMode === "assign" ? (
                    <Button
                      size="sm"
                      color="primary"
                      onClick={saveAssignRoles}
                      disabled={
                        assignSaving || assignSelectedRoles.length === 0
                      }
                    >
                      {assignSaving ? <Spinner size="sm" /> : "Assign Roles"}
                    </Button>
                  ) : (
                    <Button
                      size="sm"
                      color="primary"
                      onClick={saveEditChanges}
                      disabled={editSaving || !editAssignDoc}
                    >
                      {editSaving ? <Spinner size="sm" /> : "Save Changes"}
                    </Button>
                  )}
                </div>
              </div>
            </div>
          </Col>
        </Row>
      ) : null}
    </>
  );
}
